import React, { Component } from "react";
import moment from "moment";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "jspdf-autotable";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";

import {
  leaveApplicationStatusBadge,
  leaveApplicationCancelStatusBadge,
  main_url,
  getUserId,
} from "../../../../utils/CommonFunction";

import OutstandingLeavesFilters from "./OutstandingLeavesFilters";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class OutstandingLeavesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: getUserId("user_info"),
      filterValues: {
        selectedLeaveCategory: 0,
        selectedLeaveStatus: 0,
        selectedDesignation: 0,
        selectedDepartment: 0,
        selectedBranch: 0,
        selectedRegion: 0,
        selectedEmployee: 0,
      },
    };
  }

  get filteredLeaves() {
    let outstandingLeaves = this.props.outstandingLeaves;
    if (
      Object.values(this.state.filterValues).find((val) => {
        return val !== 0;
      })
    ) {
      const selectedLeaveCategory =
        this.state.filterValues.selectedLeaveCategory;
      const selectedLeaveStatus = this.state.filterValues.selectedLeaveStatus;
      const selectedDesignation = this.state.filterValues.selectedDesignation;
      const selectedDepartment = this.state.filterValues.selectedDepartment;
      const selectedBranch = this.state.filterValues.selectedBranch;
      const selectedRegion = this.state.filterValues.selectedRegion;
      const selectedEmployee = this.state.filterValues.selectedEmployee;

      if (selectedLeaveCategory !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.leave_category_id === selectedLeaveCategory;
        });
      }

      if (selectedLeaveStatus !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.application_status === selectedLeaveStatus;
        });
      }
      if (selectedDesignation !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.designations_id === selectedDesignation;
        });
      }
      if (selectedDepartment !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.departments_id === selectedDepartment;
        });
      }
      if (selectedBranch !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.branch_id === selectedBranch;
        });
      }
      if (selectedRegion !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.region_id === selectedRegion;
        });
      }
      if (selectedEmployee !== 0) {
        outstandingLeaves = outstandingLeaves.filter((leave) => {
          return leave.user_id === selectedEmployee;
        });
      }
      return outstandingLeaves;
    } else {
      return outstandingLeaves;
    }
  }

  componentDidMount() {
    this._setTableData();
  }

  componentDidUpdate() {
    this._setTableData();
  }

  handleFilterValue = (filter, value) => {
    const currentFilters = this.state.filterValues;
    if (currentFilters[filter] === value) return;
    currentFilters[filter] = value;

    this.setState({
      filterValues: currentFilters,
    });
  };

  _setTableData() {
    let table;
    let list = [];
    let obj,
      one = [];

    let outstandingLeaves = this.filteredLeaves;

    for (let i = 0; i < outstandingLeaves.length; i++) {
      obj = outstandingLeaves[i];

      const applicationStatusBadge = leaveApplicationStatusBadge(
        obj.application_status,
        obj.previous_status
      );
      const cancelStatusBadge = leaveApplicationCancelStatusBadge(
        obj.application_status,
        obj.cancel_reject,
        obj.cancel_approve,
        obj.cancel_verify,
        obj.leave_cancel_apply_date
      );

      one = {
        no: i + 1,
        fullname: obj.fullname,
        employment_id: obj.employment_id,
        designations: obj.designations,
        deptname: obj.deptname,
        branch_name: obj.branch_name,
        region_name: obj.region_name,
        leave_category: obj.leave_category,
        application_status: applicationStatusBadge,
        cancel_status: cancelStatusBadge,
        reason: obj.reason,
        application_date: moment(obj.application_date).format("YYYY-MM-DD"),
        leave_start_date: moment(obj.leave_start_date).format("YYYY-MM-DD"),
        leave_end_date: moment(obj.leave_end_date).format("YYYY-MM-DD"),
        leave_days: obj.leave_days,
        leave_balance: `${obj.leaves_taken} / ${obj.leaves_available}`,
        attachment: "",
      };

      if (obj.attachment) {
        one.attachment = `<a
          href=${main_url}leave/getCRDocumentData/${this.state.user_id}/${obj.attachment}
          download
          target="_blank"
          className="btn btn-primary document-body-bt document-width"
        >
          <img
              src="assets/icons/attach_file.svg"
              alt=""
              height="20"
              width="20" 
            />
        </a>`;
      }

      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-outstandingLeave")) {
      table = $("#dataTables-outstandingLeave").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-outstandingLeave").empty();
    }

    let column = [
      { title: "No", data: "no" },
      { title: "Name", data: "fullname" },
      { title: "Employee Id", data: "employment_id" },
      { title: "Designation", data: "designations" },
      { title: "Department", data: "deptname" },
      { title: "Branch", data: "branch_name" },
      { title: "Region", data: "region_name" },
      { title: "Leave Category", data: "leave_category" },
      { title: "Status", data: "application_status" },
      { title: "Cancel Status", data: "cancel_status" },
      { title: "Reason", data: "reason" },
      { title: "Apply Date", data: "application_date" },
      { title: "Start Date", data: "leave_start_date" },
      { title: "End Date", data: "leave_end_date" },
      { title: "Days Taken", data: "leave_days" },
      { title: "Balance", data: "leave_balance" },
      { title: "Attachment", data: "attachment" },
    ];

    table = $("#dataTables-outstandingLeave").DataTable({
      pageLength: 20,
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      searching: false,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: list,
      columns: column,
    });
  }

  render() {
    return (
      <div>
        <OutstandingLeavesFilters
          handleFilterValue={this.handleFilterValue}
          leaveCategories={this.props.leaveCategories}
          leaveApplicationStatusList={this.props.leaveApplicationStatusList}
          designations={this.props.designations}
          departments={this.props.departments}
          branches={this.props.branches}
          regions={this.props.regions}
          employees={this.props.employees}
          approveLeaves={this.props.approveLeaves}
          rejectLeaves={this.props.rejectLeaves}
          currentFilters={this.state.filterValues}
          filteredLeaves={this.filteredLeaves}
        />
        <div className="margin-y">
          <table
            width="99%"
            className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
            id="dataTables-outstandingLeave"
          ></table>
        </div>
        {/* Vertical Spacing */}
        <div style={{ height: "400px" }}></div>
      </div>
    );
  }
}
